/* tslint:disable */
/* eslint-disable */
/**
 * Water Bureau Admin Portal - Debug API
 * Debug APIs for development and testing purposes. These APIs bypass authentication and should only be enabled in development environments.
 *
 * The version of the OpenAPI document: debug-1.0.0
 * Contact: debug@waterbureau.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Device information in paginated listings
 * @export
 * @interface DeviceDTO
 */
export interface DeviceDTO {
    /**
     * Unique identifier of the device
     * @type {string}
     * @memberof DeviceDTO
     */
    'id'?: string;
    /**
     * Platform identifier of the device
     * @type {string}
     * @memberof DeviceDTO
     */
    'platformId'?: string;
    /**
     * IoT platform the device connects to
     * @type {string}
     * @memberof DeviceDTO
     */
    'platform'?: DeviceDTOPlatformEnum;
    /**
     * Human-readable name of the device
     * @type {string}
     * @memberof DeviceDTO
     */
    'name'?: string;
    /**
     * Serial number of the device
     * @type {string}
     * @memberof DeviceDTO
     */
    'serialNumber'?: string;
    /**
     * Type of the device
     * @type {string}
     * @memberof DeviceDTO
     */
    'type'?: DeviceDTOTypeEnum;
    /**
     * Current status of the device
     * @type {string}
     * @memberof DeviceDTO
     */
    'status'?: DeviceDTOStatusEnum;
    /**
     * ID of the customer assigned to this device
     * @type {string}
     * @memberof DeviceDTO
     */
    'customerId'?: string;
    /**
     * Name of the customer assigned to this device
     * @type {string}
     * @memberof DeviceDTO
     */
    'customerName'?: string;
    /**
     * Last communication timestamp from the device
     * @type {string}
     * @memberof DeviceDTO
     */
    'lastUpdated'?: string;
    /**
     * Battery level percentage (0-100)
     * @type {number}
     * @memberof DeviceDTO
     */
    'batteryLevel'?: number;
    /**
     * Signal strength indicator (0-5)
     * @type {number}
     * @memberof DeviceDTO
     */
    'signalStrength'?: number;
    /**
     * Number of leak alarms associated with this device
     * @type {number}
     * @memberof DeviceDTO
     */
    'leakAlarms'?: number;
    /**
     * Physical location of the device
     * @type {string}
     * @memberof DeviceDTO
     */
    'location'?: string;
    /**
     * ID of the council this device belongs to
     * @type {number}
     * @memberof DeviceDTO
     */
    'councilId'?: number;
    /**
     * Name of the council this device belongs to
     * @type {string}
     * @memberof DeviceDTO
     */
    'councilName'?: string;
}

export const DeviceDTOPlatformEnum = {
    C8y: 'c8y',
    Temetra: 'temetra',
    Onconnect: 'onconnect'
} as const;

export type DeviceDTOPlatformEnum = typeof DeviceDTOPlatformEnum[keyof typeof DeviceDTOPlatformEnum];
export const DeviceDTOTypeEnum = {
    SmartMeter: 'smart_meter',
    DataLogger: 'data_logger',
    Unknown: 'unknown'
} as const;

export type DeviceDTOTypeEnum = typeof DeviceDTOTypeEnum[keyof typeof DeviceDTOTypeEnum];
export const DeviceDTOStatusEnum = {
    Active: 'active',
    Inactive: 'inactive',
    Maintenance: 'maintenance',
    Unknown: 'unknown'
} as const;

export type DeviceDTOStatusEnum = typeof DeviceDTOStatusEnum[keyof typeof DeviceDTOStatusEnum];


